import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import DSBox from "views/system-design/DSBox";
import DSTooltip from "views/system-design/DSTooltip";
import DSTypography from "views/system-design/DSTypography";
import { Ticket } from "../../types";
import {
  formatDate,
  formatElapsedShort,
  getStatusLabel,
  getStatusSince,
} from "../../utils";

interface TimeInStatusProps {
  ticket: Pick<Ticket, "status" | "statusChangedAt" | "resolvedAt">;
}

/** "⌛ 3d" badge: how long the ticket has been in its current status. */
export default function TimeInStatus({ ticket }: TimeInStatusProps) {
  const since = getStatusSince(ticket);
  if (!since) return null;

  return (
    <DSTooltip
      title={`${getStatusLabel(ticket.status)} since ${formatDate(since)}`}
    >
      <DSBox sx={{ display: "inline-flex", alignItems: "center", gap: 0.25 }}>
        <HourglassEmptyIcon sx={{ fontSize: 12, color: "text.secondary" }} />
        <DSTypography variant="caption" sx={{ color: "text.secondary" }}>
          {formatElapsedShort(since)}
        </DSTypography>
      </DSBox>
    </DSTooltip>
  );
}
